<template>
  <Link
    v-bind="$attrs"
    :href="route('coupons.index')"
    class="click-me relative group duration-300"
  >
    <div class="relative flex p-8 pb-0 lg:p-16 z-10">
      <div class="max-w-sm">
        <h2 class="text-3xl font-bold mb-2" style="line-height: 1.1;">
          Gute Gründe auszugehen:<br>
          Abos 26/27
        </h2>
        <p>Genießen Sie die Vorzüge von früher Termin- und Platzwahl samt Preisvorteil.</p>
      </div>
      <div class="flex flex-1 items-center pl-8">
        <Icon
          class="ml-auto transition duration-300 transform group-hover:translate-x-[33.3%]"
          type="arrow-right"
          size="10"
        />
      </div>
    </div>
    <div class="lg:absolute lg:right-10 lg:top-[50%] lg:translate-y-[-50%] z-0">
      <img class="max-w-full w-[36rem] mx-auto block" src="/media/Mockup-3er-Abo.png" alt="Werbebanner für die Abos 26/27 des DAS DA THEATERS. Links steht der Text: Gute Gründe auszugehen: Abos 26/27. Genießen Sie die Vorzüge von früher Termin- und Platzwahl samt Preisvorteil. Rechts daneben ist eine schräg liegende Abo-Karte mit dem Logo des Theaters und Plakatmotiven der im Abo enthaltenen Stücke. Der Hintergrund ist ein Farbverlauf von Türkis zu Violett.">
    </div>
  </Link>
</template>

<script>
import Icon from 'Web/Shared/Icon.vue';
import Link from 'Web/Shared/Link.vue';

export default {
  inheritAttrs: false,
  components: {
    Icon,
    Link,
  }
}
</script>
